export default "__VITE_ASSET__Bz6Mgyvd__"